export default __webpack_public_path__ + "static/media/image1.94dd39ae.svg";